import { SettingsService } from "./settings-service";
import { Lazy } from "../lazy";
import { Logger } from "../../logger/logger";

export class UserSettingsService extends SettingsService {
	public static getInstance = Lazy.singleton(UserSettingsService);
	private static keyStandardMarketer = "standardmarketer";
	private static defaultMarketerId = 1;
	constructor() {
		super("usersettings");
	}

	public readonly setMarketerId = (marketerId: number) => {
		this.setItem(this.getKey(UserSettingsService.keyStandardMarketer), marketerId);
	}

	public readonly getMarketerId = () => {
		let result = parseInt(this.getItem(this.getKey(UserSettingsService.keyStandardMarketer), UserSettingsService.defaultMarketerId));
		return result;
	}
}